/**
 * @generated SignedSource<<6702353ab13bd925b147292ca2eaa075>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InstagramLinkStatus = "FACEBOOK_LOGIN_EXPIRED" | "LINKED" | "UNLINKED";
export type LinkSnsTypes = "Apple" | "Instagram" | "Line" | "Tiktok" | "Twitter" | "TwitterOAuth1";
export type UnlinkSnsMutationInput = {
  clientMutationId?: string | null;
  type: LinkSnsTypes;
};
export type OAuthUnlinkMutation$variables = {
  input: UnlinkSnsMutationInput;
};
export type OAuthUnlinkMutation$data = {
  readonly unlinkSns: {
    readonly __typename: "Influencer";
    readonly appleId: string | null;
    readonly instagramLinkStatus: InstagramLinkStatus;
    readonly lineId: string | null;
    readonly linkingInstagram: boolean | null;
    readonly linkingTiktok: boolean | null;
    readonly linkingTwitter: boolean | null;
    readonly profile: {
      readonly instaFollowers: number | null;
      readonly instaId: string | null;
      readonly instaUrl: string | null;
      readonly tiktokFollowers: number | null;
      readonly tiktokUrl: string | null;
      readonly twitterFollowers: number | null;
      readonly twitterId: string | null;
    };
  } | {
    readonly __typename: "UnlinkSnsError";
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type OAuthUnlinkMutation = {
  response: OAuthUnlinkMutation$data;
  variables: OAuthUnlinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkingInstagram",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instagramLinkStatus",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkingTwitter",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkingTiktok",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appleId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterFollowers",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "twitterId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instaFollowers",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instaId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "instaUrl",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tiktokUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tiktokFollowers",
  "storageKey": null
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UnlinkSnsError",
  "abstractKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OAuthUnlinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "unlinkSns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OAuthUnlinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "unlinkSns",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v17/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v16/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a1c16ddcb4e70daaa69651a947757dc4",
    "id": null,
    "metadata": {},
    "name": "OAuthUnlinkMutation",
    "operationKind": "mutation",
    "text": "mutation OAuthUnlinkMutation(\n  $input: UnlinkSnsMutationInput!\n) {\n  unlinkSns(input: $input) {\n    __typename\n    ... on Influencer {\n      linkingInstagram\n      instagramLinkStatus\n      linkingTwitter\n      linkingTiktok\n      lineId\n      appleId\n      profile {\n        twitterFollowers\n        twitterId\n        instaFollowers\n        instaId\n        instaUrl\n        tiktokUrl\n        tiktokFollowers\n        id\n      }\n      id\n    }\n    ... on UnlinkSnsError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3da2337dd1397a426d5ceff2d86f4f57";

export default node;
